import { ClientProfileViewModel } from '@common/model/client';

export const getNameSurname = (data: Pick<ClientProfileViewModel, 'name' | 'surname'>) =>
  [data.name, data.surname].filter(Boolean).join(' ');
